import { Component, signal } from '@angular/core';
import { RgsharedserviceService } from '../../../Services/RGService/rgsharedservice.service';
import { RgserviceService } from '../../../Services/RGService/rgservice.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-rg-first-selection',
  templateUrl: './rg-first-selection.component.html',
  styleUrl: './rg-first-selection.component.css'
})
export class RgFirstSelectionComponent {
  scrollToCommonSecondComponent() {
    const hpSecondComponent = document.querySelector('app-second-selection');
    if (hpSecondComponent) {
      hpSecondComponent.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
  signalStatus:boolean=false;
  panelOpenState = signal(this.signalStatus);
  specData:any={};
  sizeSpeedRatio:any={
    size:"",
    ratio:"",
    speed:"",
    inputPower:"",
    units:""
  };
  
  userSelectedData:any={};
  public showcdinfo:boolean=false;
  public showspinfo:boolean=false;
  // formData: any;
constructor(private rgSharedService:RgsharedserviceService, private rgService:RgserviceService,private router:Router){}
  ngOnInit(){
    const url=this.router.url.toLowerCase();
    const currentUrl = window.location.href.toLowerCase();
    if (currentUrl.includes('spineatools'))
    {
        this.showspinfo=true;
        this.showcdinfo=false;
    }
    else
    {
        this.showspinfo=false;
        this.showcdinfo=true;
    }
    this.signalStatus=true;
    this.panelOpenState = signal(this.signalStatus);
    this.rgSharedService.specification$.subscribe((specificationData:any) => 
      {
        debugger;
        this.sizeSpeedRatio.size = specificationData.size.replace(/[a-zA-Z]/g, '');
        this.sizeSpeedRatio.speed = specificationData.speed
        this.sizeSpeedRatio.ratio = specificationData.ratio
        this.specData={
          Size: ((specificationData.size).replace(/[a-zA-Z]/g, '')=="N/A")?(specificationData.size).replace(/[a-zA-Z]/g, ''):(specificationData.size).replace(/[a-zA-Z]/g, '') ||"Null",
          Ratio: ((specificationData.ratio)=="N/A")?specificationData.ratio:specificationData.ratio || "null",
          Speed:((specificationData.speed)=="N/A")?specificationData.speed:specificationData.speed + " rpm" || "null",
          NominalBacklash:specificationData.backlash,
          MechanicalInputPowerImperial:((specificationData.inputpoweR_MECH)=="N/A")?specificationData.inputpoweR_MECH:specificationData.inputpoweR_MECH + " HP"||"null",
          MechanicalInputPowerMetric:((specificationData.inputpoweR_MECH_KW)=="N/A")?specificationData.inputpoweR_MECH_KW:specificationData.inputpoweR_MECH_KW + " KW" || "null",
          ThermalInputPowerImperial:((specificationData.inputpoweR_THEM)=="N/A")?specificationData.inputpoweR_THEM:specificationData.inputpoweR_THEM + " HP" || "null",
          ThermalInputPowerMetric:((specificationData.inputpoweR_THEM_KW)=="N/A")?specificationData.inputpoweR_THEM_KW:specificationData.inputpoweR_THEM_KW + " KW" || "null",
          MechanicalOutputTorqueImperial:((specificationData.outputtorquE_MECH)=="N/A")?specificationData.outputtorquE_MECH.replace(/,/g, ''):specificationData.outputtorquE_MECH.replace(/,/g, '') + " lb-in" || "null",
          MechanicalOutputTorqueMetric:((specificationData.outputtorquE_MECH_NM)=="N/A")?specificationData.outputtorquE_MECH_NM:specificationData.outputtorquE_MECH_NM + " Nm" || "null",
          MaximumOutputTorqueImperial:((specificationData.outputtorquE_MAX)=="N/A")?specificationData.outputtorquE_MAX:specificationData.outputtorquE_MAX + " lb-in" || "null",
          MaximumOutputTorqueMetric:((specificationData.outputtorquE_MAX_NM)=="N/A")?specificationData.outputtorquE_MAX_NM:specificationData.outputtorquE_MAX_NM + " Nm" || "null",
          EfficiencyImperial:((specificationData.efficiency)=="N/A")?specificationData.efficiency:specificationData.efficiency + " %" || "null",
          EfficiencyMetric:((specificationData.efficiency)=="N/A")?specificationData.efficiency:specificationData.efficiency + " %" || "null",
          TorsionalStiffnessImperial:((specificationData.torsionalstiffnessimperial) == "N/A")?specificationData.torsionalstiffnessimperial:specificationData.torsionalstiffnessimperial + " lb.in/min" || "null",
          TorsionalStiffnessMetric:((specificationData.torsionalstiffnessmetric)=="N/A")?specificationData.torsionalstiffnessmetric:specificationData.torsionalstiffnessmetric + " Nm/min" || "null",
          RotationalInertiaImperial: ((specificationData.rotationalinertiaimperial)=="N/A")?specificationData.rotationalinertiaimperial:specificationData.rotationalinertiaimperial + " lb.in.s^2 x 10^-4" || "null",
          RotationalInertiametric:((specificationData.rotationalinertiametric)=="N/A")?specificationData.rotationalinertiametric:specificationData.rotationalinertiametric + " kg.cm^2" || "null",
          ApproximateProductWeightImperial:((specificationData.weightlbs)=="N/A")?specificationData.weightlbs:specificationData.weightlbs + " lb" || "null",
          ApproximateProductWeightMetric:((specificationData.weightlbs)=="N/A")?specificationData.weightlbs:specificationData.weightlbs + " kg" || "null",
          specServiceFactor:(specificationData.specServiceFactor=="N/A")?specificationData.specServiceFactor : specificationData.specServiceFactor
        }

const specSFElements = document.getElementsByClassName('sericeFactorStyle');
for (let i = 0; i < specSFElements.length; i++) {
  const element = specSFElements[i] as HTMLElement;
  if (Number(specificationData.specServiceFactor) < Number(this.userSelectedData.SelectedServiceFactor)) {
      element.style.setProperty('background-color', '#dc3545', 'important');
  } else {
      element.style.setProperty('background-color', '#28a745', 'important');
  }
}

      });
      this.rgSharedService.getFormData().subscribe(data => {
        this.sizeSpeedRatio.inputPower = data.selectedInputPower;
        this.sizeSpeedRatio.units = data.selectedUnits;
        this.userSelectedData={
          SelectedInputPower:data.selectedInputPower || "Null",
          SelectedUnits:data.selectedUnits || "Null",
          SelectedSpeed:data.selectedSpeed || "Null",
          SelectedRatio:data.selectedRatio || "Null",
          SelectedDutyCycle:data.selectedDutyCycle || "Null",
          SelectedServiceFactor:data.selectedServiceFactor || "Null",
          SelectedOutputSpeed:data.selectedOutputSpeed || "Null"
        };
      });
    
  }
  largerReducer():void{
    const params={
      Size: "RG"+this.sizeSpeedRatio.size,
      Ratio:this.sizeSpeedRatio.ratio,
      Speed:this.sizeSpeedRatio.speed,
      Inputpower_Them : this.sizeSpeedRatio.inputPower,
      units: this.sizeSpeedRatio.units
    };
    this.rgService.getRGLargerReducer(params).subscribe(result=>{
      if(result.body==null){
        alert("No Larger Size available")
      }else
      {
        this.rgSharedService.setSpecification(result.body);
      }
      
      console.log(this.specData);
    });
  }
  smallerReducer():void{
    const params={
      Size: "RG"+this.sizeSpeedRatio.size,
      Ratio:this.sizeSpeedRatio.ratio,
      Speed:this.sizeSpeedRatio.speed,
      Inputpower_Them : this.sizeSpeedRatio.inputPower,
      units: this.sizeSpeedRatio.units
    };
    this.rgService.getRGSmallerReducer(params).subscribe(result=>{
      if(result.body==null){
        alert("No Smaller Size available")
      }else
      {
        this.rgSharedService.setSpecification(result.body);
      }
      
      console.log(this.specData);
    });
  }
  reducerFeature():void{
    this.rgSharedService.setSize(this.sizeSpeedRatio);
  }
}
